import { useQuery } from 'react-query';
import { queryKey } from 'constants/queryKey';
import PageApi from 'api/page';

export const useDefaultPageAlbumId = (pageId: number, shouldFetch = true) => {
  const { data } = useQuery(
    queryKey.pageDetail(pageId),
    () => PageApi.detail(pageId),
    { enabled: shouldFetch && pageId > 0 },
  );

  return data?.defaultAlbum ?? undefined;
};
